import './MarketiStatistics.less';

import React from 'react';
import MarketStatisticsDetail from './MarketStatisticsDetail';
import { isMobile } from 'react-device-detect';
import i18n from '../../../common/i18n';
import clsx from 'clsx';

export function MarketStatisticsHeader({ live, headerCenter }) {
    return (
        <div
            className={clsx('c-default-light fs-14 px-20', {
                'text-center': headerCenter,
                'py-30': isMobile,
                'py-20': !isMobile
            })}
        >
            {live ? i18n('nui.marketStatistics.info.infoTextLive') : i18n('nui.marketStatistics.info.infoTextPrematch')}
        </div>
    );
}

function MarketStatistics({ bet, isSelected, addPick, oddColored, live }) {
    return (
        <MarketStatisticsDetail
            stats={bet}
            isSelected={isSelected}
            addPick={addPick}
            oddColored={oddColored}
            live={live}
        />
    );
}

export default MarketStatistics;
